import axios from './axios';
const API_URL = '/C4-Nicaragua/Reportes'; // ajusta si usas otro endpoint

export const getReportes = async (payload) => {
  try {
    const response = await axios.post(API_URL, payload);

    return response.data;
  } catch (error) {
    console.error('Error al obtener reporte:', error);
    return [];
  }
};